import { FC } from 'react';

import { MetricDefinitionNode } from '@/__generated__/graphql';
import { DetailsSection } from '@/components/SectionWithCard';
import { CollapsibleSection } from '@/pages/account/project/resource/details/components/CollapsibleSection';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { PanelDetails } from './panelDetailTypes';

interface MetricFilterTableProps {
  uniqueId: ParsedUniqueId;
  accountId: number;
  projectId: number;
  projectName: string;
  environmentId?: number;
  compact?: boolean;
  className?: string;
  metric: MetricDefinitionNode;
  children?: (details: PanelDetails) => React.ReactNode;
}

export const MetricFilterTable: FC<MetricFilterTableProps> = ({ metric }) => {
  if (!metric || !metric.filter) {
    return null;
  }

  const whereExpressions = metric.filter.where_filters.map(
    (f: any) => f.where_sql_template,
  );

  // const content = JSON.stringify(whereExpressions).replace(/\\n/g, '<br />');
  return (
    <DetailsSection withCard={false}>
      <div className="overflow-hidden rounded-md border border-borderMuted">
        {whereExpressions && whereExpressions.length > 0 && (
          <CollapsibleSection
            closeAltText={`Hide query params segment`}
            expandAltText={`Show query params segment`}
            toExpand={
              <>
                {whereExpressions.map((expression: string, index: number) => (
                  <pre key={index} className="whitespace-pre-wrap p-4 text-sm">
                    <code
                      className="align-middle text-fgDecorative"
                      dangerouslySetInnerHTML={{
                        __html: expression.replace(/\\n/g, '<br />'),
                      }}
                    ></code>
                  </pre>
                ))}
              </>
            }
            disable={whereExpressions.length === 0}
            shouldIndent={whereExpressions.length > 0}
            className="-mb-[1px] mt-1 flex w-full overflow-hidden border-b border-borderMuted p-4"
          >
            <span>
              <p className="mx-2 align-middle text-base font-semibold">Filters</p>
            </span>
          </CollapsibleSection>
        )}
      </div>
    </DetailsSection>
  );
};
